<template>
  <v-layout column>
    <vbt-search
      v-model="searchData"
      :items="searchFieldsConfig"
      @reset="onResetSearch"
      @search="onSearch"
    />

    <vbt-content-box
      :loading="isLoading"
      :loading-error="loadingError"
      :no-content="noContent"
      :go-back-btn="goBack"
      title="Information"
    >
      <template #toolbar>
        <v-btn
          small
          color="success"
          @click="openEditorDialog()"
        >
          Create substrate
        </v-btn>
      </template>
      <vbt-table
        :items="substrates"
        :headers="headers"
        show-edit-action
        @click:edit="openEditorDialog"
      >
        <template #state="{ item: { state } }">
          <kernel-status-badge :status="substrateStatusEnumByValue[state]">
            {{ state }}
          </kernel-status-badge>
        </template>
      </vbt-table>

      <vbt-pagination
        v-model="pageNum"
        :items-count="pagedItemsCount"
        :total-count="substratesTotalCount"
      />
    </vbt-content-box>

    <kernel-substrate-editor
      v-model="editorDialog"
      :creator="isEditorCreateMode"
      :item="editableSubstrate"
      @success="$_fetchData"
    />
  </v-layout>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import {
  useEditorWithDialog,
  useDataLoading,
  usePagination,
  useSearch,
} from '@mixins/factories';

import { namespace as EnumsNamespace } from '@store/modules/enums.types';
import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import { namespace as SubstratesNamespace, ActionTypes as SubstratesActionTypes } from '../store.types';

import KernelSubstrateEditor from '../_components/KernelSubstrateEditor.vue';

const dataLoadingOptions = { getterName: SubstratesActionTypes.GET_SUBSTRATES, contentName: 'substrates' };
const paginationOptions = { contentName: 'substrates' };
const searchOptions = {
  initialSearchDataStates: [
    'state', 'name',
  ],
};

const headers = Object.freeze([
  { text: 'Name', value: 'name' },
  { text: 'Abbreviation', value: 'abbreviation' },
  { text: 'State', value: 'state' },
  { text: 'Thickness', value: 'thickness' },
]);
export default {
  name: 'KernelSubstrates',
  components: {
    KernelSubstrateEditor,
  },
  mixins: [
    useEditorWithDialog({ editableItemName: 'editableSubstrate' }),
    useDataLoading(dataLoadingOptions),
    usePagination(paginationOptions),
    useSearch(searchOptions),
  ],
  data: () => ({ headers }),
  computed: {
    ...mapState(SubstratesNamespace, ['substrates', 'substratesTotalCount']),
    ...mapState(LocationsNamespace, ['suffix']),
    ...mapState(EnumsNamespace, {
      substrateStatuses: ({ enums: { substrateStatus: enums } }) => (enums || [])
        .map(({ value }) => value),
    }),
    ...mapGetters(EnumsNamespace, ['substrateStatusEnumByValue']),
    searchFieldsConfig() {
      return [
        { value: 'name', label: 'Name', type: 'text' },
        {
          value: 'state',
          items: this.substrateStatuses,
          label: 'State',
          type: 'select',
        },
      ];
    },
  },
  watch: {
    suffix: '$_refreshData',
  },
  methods: {
    ...mapActions(SubstratesNamespace, [SubstratesActionTypes.GET_SUBSTRATES]),
  },
};
</script>
